var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 559.98 559.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.71,440.53c0-17.53-14.2-31.75-31.72-31.75s-31.73,14.22-31.73,31.75v87.74c0,17.5,14.2,31.72,31.73,31.72s31.72-14.22,31.72-31.72v-87.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.71,31c-.41-17.18-14.44-31-31.72-31s-31.32,13.82-31.72,31h-.02V119.47c0,17.52,14.2,31.73,31.73,31.73s31.72-14.22,31.72-31.73V31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.94,433.08l-61.96-61.96s-.02-.03-.04-.03c-12.39-12.41-32.49-12.41-44.88,0-12.39,12.37-12.39,32.47,0,44.88l62.03,62.04c12.39,12.38,32.49,12.38,44.87,0,12.39-12.41,12.39-32.51,0-44.88t-.03-.04h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.49,126.38l62.55,62.53v.04c12.41,12.37,32.5,12.37,44.88-.02,12.41-12.39,12.41-32.49,0-44.88l-62-61.98s0-.04-.04-.05c0,0-.02-.02-.03-.04l-.48-.48v.02c-12.44-11.89-32.13-11.72-44.36,.5-12.2,12.22-12.38,31.92-.5,44.35l-.02,.02Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.23,248.27h-87.72c-17.52,0-31.74,14.2-31.74,31.72s14.22,31.75,31.74,31.75h87.72c17.53,0,31.75-14.22,31.75-31.75s-14.22-31.72-31.75-31.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.44,311.74h.02c17.53,0,31.73-14.22,31.73-31.75s-14.2-31.72-31.73-31.72H31c-17.19,.41-31,14.44-31,31.72s13.81,31.31,31,31.72v.04H119.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.94,188.92l62.03-62.02c12.39-12.41,12.39-32.5,0-44.89-12.39-12.39-32.48-12.39-44.88,0t-.04,.05l-61.96,61.95s-.02,.02-.03,.04c-12.39,12.39-12.39,32.49,0,44.88,12.39,12.39,32.48,12.39,44.88,0h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.03,371.08l-62,62s-.02,0-.03,.04c0,0-.02,0-.04,.04l-.48,.48h.02c-11.88,12.44-11.71,32.12,.5,44.37,12.23,12.2,31.92,12.38,44.36,.51l62.55-62.55c12.41-12.41,12.41-32.5,0-44.88-12.38-12.41-32.47-12.41-44.88,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingWhite);
export default __webpack_public_path__ + "static/media/loading-white.0c459ad5ffafef5ca7e82a7c39b12e6c.svg";
export { ForwardRef as ReactComponent };